
import { Component, Watch } from "vue-property-decorator";
import BaseAuthenticatedView from "@/views/BaseAuthenticatedView.vue";
import { PercentIndicator } from "@/mixins/percentIndicatorMixin";
import ExchangeMixin from "@/mixins/exchangeMixin";
import { Exchange } from "@/models/Exchange";

@Component({
  components: {
    ConfirmationDialog: () => import("@/components/ConfirmationDialog.vue"),
    ConnectExchangeDialog: () =>
      import("@/components/exchange/ConnectExchangeDialog.vue"),
    ConnectExchangeForm: () =>
      import("@/components/exchange/ConnectExchangeForm.vue"),
    EditExchangeDialog: () => import("./components/EditExchangeDialog.vue"),
  },
  mixins: [PercentIndicator, ExchangeMixin],
})
export default class ConnectedExchanges extends BaseAuthenticatedView {
  // 📦 The exchange index that is marked to be deleted
  private exchangeIndexToBeDeleted: number | null = null;

  // 📦 The exchange index that is marked to be edited
  private exchangeIndexToBeEdited: number | null = null;

  // 🚩 Flag responsible for determining whether the initial exchange connection should be shown
  private get showInitialExchangeConnection(): boolean {
    return this.connectedExchanges && this.connectedExchanges.length == 0;
  }

  // 🚩 Flag responsible for determining whether the remove exchange connection dialog should be shown
  private showRemoveExchangeDialog: boolean = false;

  // 🚩 Flag responsible for determining whether the exchange connection dialog should be shown
  private showConnectExchangeDialog: boolean = false;

  // 🚩 Flag responsible for determining whether the edit exchange connection dialog should be shown
  private showEditExchangeConnectionDialog: boolean = false;

  // 📦 Headers needed for the referrals table
  private connectedExchangesTableHeaders = [
    { text: "Exchange", value: "exchange", sortable: false },
    { text: "Status", value: "status", sortable: false },
    {
      text: "Automated Trading",
      value: "automatedTradingStatusDetails",
      sortable: false,
    },
    { text: "", value: "actions", sortable: false },
  ];

  // 🔃 Flag responsible for enabling / disabling loading indicator
  private get loading(): boolean {
    return this.$store.state.exchanges.loading;
  }

  // 📦 The exchanges the user has connected
  private get connectedExchanges(): ConnectedExchanges[] {
    return this.$store.state.exchanges.connectedExchanges;
  }

  // 🚩 Flag which determines whether the button for adding more exchange accounts should be visible
  private get showAddAnotherAccountButton(): boolean {
    return (
      this.connectedExchanges.length < this.$store.getters.allExchanges.length
    );
  }

  protected async mounted() {
    super.mounted();

    this.$store.dispatch("fetchAllExchanges");

    this.$store.subscribe((mutation, state) => {
      if (mutation.type == "publishExchangeConnected" && mutation.payload) {
        this.showConnectExchangeDialog = false;
        this.$store.dispatch("fetchConnectedExchanges");
      }
    });
  }
}
